import sizes from './sizes'
import colors from './colors'

export default {
  SP_LIGHT: {
    fontFamily: 'Ride Light',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '300'
  },
  SP_REGULAR: {
    fontFamily: 'Ride Regular',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '400'
  },
  SP_BOLD: {
    fontFamily: 'Ride Bold',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '700'
  },
  SP_SEMIBOLD: {
    fontFamily: 'Ride Medium',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '600'
  }
}
